import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";

export const InvoiceManageSummary = () => {

    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}